import {removeSourceRange} from './sequence.js';
import {retainedIntervals} from './editModel.js';

/** A protected word is never suggested for removal. Existing edits stay protected. */
export function cleanupProtectedRanges(words,priorityWordIds={},assemblyWordIds=[],cuts=[],duration=0){
 const assembly=new Set(assemblyWordIds);
 // Parse existing cuts only once; large professional interviews have many words.
 const retained=retainedIntervals(cuts,duration);
 const protectedIndexes=[];
 words.forEach((w,index)=>{
  if(priorityWordIds[w.id]==='must'||assembly.has(w.id)||!retained.some(part=>w.start<part.end&&w.end>part.start))
   protectedIndexes.push(index);
 });
 const spans=[];
 for(const index of protectedIndexes){
  const last=spans.at(-1);
  if(last&&last.end===index-1)last.end=index;
  else spans.push({start:index,end:index});
 }
 return spans;
}
export function safeCleanupSuggestions(suggestions,words,protectedRanges=[]){
 if(!Array.isArray(suggestions))throw new Error('Invalid AI Cleanup response.');
 const blocked=i=>protectedRanges.some(r=>i>=r.start&&i<=r.end);
 const safe=[];
 for(const item of suggestions){
  if(!Number.isInteger(item.start)||!Number.isInteger(item.end)||item.start<0||
     item.end<item.start||item.end>=words.length||item.end-item.start>119||
     !['crew','false_start','filler','off_topic'].includes(item.category)||
     typeof item.reason!=='string'||!item.reason.trim())throw new Error('Invalid AI Cleanup suggestion.');
  if(Array.from({length:item.end-item.start+1},(_,k)=>item.start+k).some(blocked))continue;
  if(safe.some(other=>item.start<=other.end&&item.end>=other.start))throw new Error('Overlapping cleanup suggestions.');
  safe.push({...item});
 }
 return safe;
}
export function applyCleanupToInterview(interview,suggestions,expectedWordIds){
 if(!interview?.words?.length||!Array.isArray(expectedWordIds)||
    expectedWordIds.length!==interview.words.length||
    interview.words.some((word,i)=>word.id!==expectedWordIds[i]))
  throw new Error('The interview transcript changed. Run AI Cleanup again.');
 let next=interview;
 for(const suggestion of suggestions){
  const start=interview.words[suggestion.start].start;
  const end=interview.words[suggestion.end].end;
  if(end<=start||start<0||end>interview.duration+.05)
   throw new Error('A cleanup suggestion has invalid timing.');
  next=removeSourceRange(next,start,end);
 }
 return next;
}
export const cleanupSignature=source=>JSON.stringify({
 words:(source?.words||[]).map(w=>[w.id,w.text,w.start,w.end]),
 cuts:source?.cuts||[],clips:source?.clips||[]
});
